import { Component, OnInit } from '@angular/core';
import { MdDialog } from '@angular/material';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { AppConfig } from './../../Common/appConfiguration';
import { userRole_candidate } from './../../Common/appConstant';
import { AppGlobals } from './../../Common/Services/app.global';
import { SharedService } from './../../Common/Services/shared.service';
import { Utility } from './../../Common/Services/utility';
import { DialogExamDetailsComponent } from './../dialog-exam-details/dialog-exam-details.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  dashboardModel: any;
  paramExamStatusCode: string;
  headerStatus: number;
  submitInProcess: boolean;
  isexamsListTDateError: boolean; // used variable for From date & To Date validations

  constructor(private _router: Router, public _utility: Utility, private _activatedRoute: ActivatedRoute
    , private _appGlobals: AppGlobals, private _sharedService: SharedService
    , public _dialog: MdDialog, public _appConfig: AppConfig) {

  }

  ngAfterContentInit() {
    //you can get to the element content here
  }

  ngOnInit() {
    this._utility.clearTxnStatus();
    let DEFAULT_EXAMS_FILTER_TYPE_INDEX = 4;
    let examsFilterTypes =
        [
            { code: 'EXAMSTOSCHEDULE', text: 'Exams to Schedule', iconUrl: './assets/images/Artboard1.png', leftMenuIconUrl: './assets/images/Artboard2.png', showDates: false, orderNo: 1 },
            { code: 'SCHEDULED', text: 'Exams Scheduled', iconUrl: './assets/images/Artboard4.png', leftMenuIconUrl: './assets/images/Artboard3.png', showDates: true, orderNo: 2 },
            { code: 'COMPLETED', text: 'Exams Taken (Completed/No Show)', iconUrl: './assets/images/Artboard9.png', leftMenuIconUrl: './assets/images/Artboard10.png', showDates: true, orderNo: 5 },
            { code: 'EXAMSEXPIRED', text: 'Exams Expired', iconUrl: './assets/images/Artboard11.png', leftMenuIconUrl: './assets/images/Artboard12.png', showDates: false, orderNo: 6 },
            { code: 'ALL', text: 'All Exams', iconUrl: './assets/images/Artboard13.png', leftMenuIconUrl: './assets/images/Artboard14.png', showDates: true, orderNo: 7 }
        ];

    this.dashboardModel = {
      examsFilterTypes: examsFilterTypes,
      selectedExamFilterType: null,
      userInfo: {},
      examsList: [],
      showCalendar: false,
      examsListFDate: new Date(), // set current date
      examsListTDate: new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate()), // set next one year date from current date
      selectedExamsListType: null,
      selectedExamModel: {},
      idStatusShow: false,
      countryList: [],
      selectedCountry: {},
    };
    // subscribe to router event
    this._activatedRoute.params.subscribe((params: Params) => {
      let exStatus = params['exStatus'];
      if (exStatus) {
        this.paramExamStatusCode = exStatus;
        let temp_paramExamStatusCode = this.paramExamStatusCode;
        let temp_selectedExamFilterType = examsFilterTypes.find(function (exam) {
          return exam.code.toUpperCase() === temp_paramExamStatusCode.toUpperCase();
        });
        if (temp_selectedExamFilterType) {
          this.dashboardModel.selectedExamFilterType = temp_selectedExamFilterType;
        }
      }

      if (!this.dashboardModel.selectedExamFilterType) {
        this.dashboardModel.selectedExamFilterType = this.dashboardModel.examsFilterTypes[DEFAULT_EXAMS_FILTER_TYPE_INDEX]; //default selected is all exam
      }
      this.changeExamsList();
    });

    this.headerStatus = 0;
    this._utility.removeFromLStorage('selectedExamModel');
    this._utility.removeFromLStorage('selectedExamLocationModel');
    this._appGlobals.currentRoute.next(this._router.url);
    this.setProfile();
  }

  ngOnDestroy() {}

  // dateChanged() event of InputDates
  private dateChanged(newDate: any = null, callFrom: string = null) {
    if (newDate != null && callFrom != null) {
      if (callFrom == 'f') {
        this.dashboardModel.examsListFDate = newDate;
      }
      else if (callFrom == 't') {
        this.dashboardModel.examsListTDate = newDate;
      }
    }
    if (this.dashboardModel.examsListTDate < this.dashboardModel.examsListFDate) {
      this.isexamsListTDateError = true;
    }
    else {
      this.isexamsListTDateError = false;
      this.changeExamsList();
    }
  }

  // to open Exam details _dialog
  openExamDetailsDialog() {
    let dialogRef = this._dialog.open(DialogExamDetailsComponent,
      {
        data: this.dashboardModel
      });
    dialogRef.afterClosed().subscribe(result => {
      // refresh the exams list if user cancelled an exam
      if (result == 1) {
        this.changeExamsList(null, false);
      }
    });
  }

  /**
   * If LogedIn user Role is Candidate then fetch data from already saved data in UserInfo object
   * If LogedIn User role is anything else then hit a request user.json and get data (This scneario is for When Admin works as a Candidate)
  */
  setProfile() {
    let resultData;
    let userRole = this._appGlobals.userInfo.getValue().userRole;

    if (userRole == userRole_candidate) {
      resultData = this._appGlobals.userInfo.getValue();
      this.dashboardModel.userInfo = resultData; // update result in dashboard model , it is used in Candidate flow
      this._appGlobals.candidateEmail = resultData.email;

    } else {
      this._sharedService.getUserProfile()
        .subscribe((data: any) => {
            this._utility.onSuccessCallback(data, null, ()=> {
              resultData = data.response;
              this.dashboardModel.userInfo = resultData; // update result in dashboard model , it is used in Candidate flow
              this._appGlobals.candidateEmail = resultData.email;
            });
          }, error => this._utility.onErrorCallback(error));
    }
  }

  // to change exams list records according to selected filter
  changeExamsList(listType: any = null, addLoader: boolean = true) {
    if (listType == null || listType == '') {
      listType = this.dashboardModel.selectedExamFilterType;
    }
    else {
      this.dashboardModel.selectedExamFilterType = listType;
    }
    if (listType != null && listType != '') {
      let params = "?status=" + listType.code;
      params += '&useLocationTimeZone=true';
      let fDate = this.dashboardModel.examsListFDate;
      let lDate = this.dashboardModel.examsListTDate;
      if (fDate != null && lDate != null) {
        params += '&fromDate=' + this._utility.convertToDateStr(fDate, 'd');
        params += '&toDate=' + this._utility.convertToDateStr(lDate, 'd');
        this.setExamsList(params, addLoader);
      }
    }
  }

  // call API to get exams list
  setExamsList(getEligibilitiesParam: string, addLoader: boolean = true) {
    this.submitInProcess = true;
    if (addLoader == true) {
      this._utility.addLoaderCount();
    }
    this._sharedService.getEligibilities(getEligibilitiesParam)
      .subscribe(
        (data: any) => {
          this._utility.onSuccessCallback(data, null, () => {
            const resultMap = new Map([
              [
                "", {
                  icon: "",
                  display: "",
                }
              ],
              [
                "PASS", {
                  icon: "check_circle",
                  display: "Pass",
                }
              ],
              [
                "NOPASS",
                {
                  icon: "cancel",
                  display: "No Pass",
                }
              ],
              [
                "PENDING",
                {
                  icon: "pending",
                  display: "Pending",
                }
              ],
              [
                "NOT_AVAILABLE",
                {
                  icon: "close",
                  display: "Not available"
                }
              ]
            ])
            if (data && data.response && data.response.results) {
              this.dashboardModel.examsList = data.response.results;
              this.dashboardModel.examsList.forEach(exam => {
                exam["retakesLeft"] = exam["retakesAvailable"] - exam["retakesGranted"];
                const result = resultMap.get(exam["resultsStatus"]);
                exam["result"] = result.display;
                exam["resultIcon"] = result.icon;
              })
            }
          }, addLoader);
        },
        error => {
          this._utility.onErrorCallback(error, null, addLoader);
          this.dashboardModel.examsList = [];
        },
        () => {
          this.submitInProcess = false;
        }
      );
  }

  // set selected exam details and open it in dialog
  setExamDetails(exam) {
    this.dashboardModel.selectedExamModel = {};
    if (exam != null) {
      this.dashboardModel.selectedExamModel = exam;
      this.openExamDetailsDialog();
    }
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/dashboard/dashboard.component.ts